/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cd_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is my target date saved anywhere?`)
};

const es_cd_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Se guarda mi fecha objetivo en algún sitio?`)
};

const de_cd_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird mein Zieldatum irgendwo gespeichert?`)
};

const nl_cd_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wordt mijn doeldatum ergens opgeslagen?`)
};

const fr_cd_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ma date cible est-elle enregistrée quelque part ?`)
};

const it_cd_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La mia data obiettivo viene salvata da qualche parte?`)
};

const pt_br2_cd_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minha data alvo é salva em algum lugar?`)
};

const pt_cd_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A minha data alvo fica guardada nalgum lado?`)
};

const ja_cd_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目標日時はどこかに保存されますか?`)
};

const zh_cd_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我的目标日期会被保存在哪里吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cd_faq_q4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cd_faq_q4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cd_faq_q4", locale)
	if (locale === "en") return en_cd_faq_q4(inputs)
	if (locale === "es") return es_cd_faq_q4(inputs)
	if (locale === "de") return de_cd_faq_q4(inputs)
	if (locale === "nl") return nl_cd_faq_q4(inputs)
	if (locale === "fr") return fr_cd_faq_q4(inputs)
	if (locale === "it") return it_cd_faq_q4(inputs)
	if (locale === "pt-BR") return pt_br2_cd_faq_q4(inputs)
	if (locale === "pt") return pt_cd_faq_q4(inputs)
	if (locale === "ja") return ja_cd_faq_q4(inputs)
	return zh_cd_faq_q4(inputs)
};